export const WHATSAPP_URL = "https://api.whatsapp.com/send?text=";

export const COMMON_BUTTON_CSS =
  "flex cursor-pointer items-center justify-center whitespace-nowrap rounded-full border border-solid border-gray-175 text-center !font-poppins text-gray-850 transition-all duration-150 hover:border-gray-850 data-[size=lg]:h-[68px] data-[size=md]:h-[42px] data-[size=sm]:h-[36px] data-[size=xs]:h-[24px] font-semibold text-xs tracking-[0.02em]";

export const REMOVE_FOCUS_CSS =
  "!outline-none focus-within:outline-none focus:outline-none outline-0 focus-within:outline-0 focus:outline-0";
